/**
 * Formata uma data no formato ISO 8601 (ex: 2025-09-30T00:00:00Z)
 * para o formato DD-MM-YYYY (ex: 30-09-2025)
 * @param {string} dateString - Data no formato ISO 8601
 * @returns {string} Data formatada no formato DD-MM-YYYY
 */
export const formatDate = dateString => {
  if (!dateString) return ''
  try {
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  } catch (error) {
    console.error('Erro ao formatar data:', error)
    return ''
  }
}

/**
 * Transforma uma data no formato DD-MM-YYYY (ex: 01-12-2025)
 * para o formato DD/MM/YYYY (ex: 01/12/2025)
 * @param {string} dateString - Data no formato DD-MM-YYYY
 * @returns {string} Data formatada no formato DD/MM/YYYY
 */
export const formatHyphenToSlash = dateString => {
  if (!dateString) return ''
  try {
    // Verifica se a data está no formato esperado DD-MM-YYYY
    if (
      typeof dateString !== 'string'
      || !/^\d{2}-\d{2}-\d{4}$/.test(dateString)
    ) {
      console.warn('Data não está no formato DD-MM-YYYY:', dateString)
      return dateString
    }

    // Substitui os hifens por barras
    return dateString.replace(/-/g, '/')
  } catch (error) {
    console.error('Erro ao transformar formato da data:', error)
    return ''
  }
}
